import { GridFields } from 'components';
import { useIsFormEditable } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';
import { Field } from 'modules/client/common/forms/contactsForm';

import { phoneValidation } from '../../../helpers/validations';

interface Props {
  hidePhoneField?: boolean;
  title?: string;
  isEditAllowed?: boolean;
}

export const ContactsSection = ({
  title,
  hidePhoneField,
  isEditAllowed = false,
}: Props) => {
  const { t } = useTranslation();

  const isEditable = useIsFormEditable();

  const isFieldsReadOnly = !isEditAllowed || !isEditable;
  const isFieldsDisabled = !isEditAllowed && isEditable;

  return (
    <Section
      datax="contactsSection"
      title={title ?? t('client.client.contacts.title')}
    >
      <GridFields>
        <Field.Text
          fullWidth
          disabled={isFieldsDisabled}
          label={t('client.client.contacts.email.label')}
          name="contacts.email"
          placeholder={t('client.client.contacts.email.placeholder')}
          readOnly={isFieldsReadOnly}
          type="email"
        />
        {!hidePhoneField && (
          <Field.Text
            fullWidth
            checkValue={phoneValidation}
            disabled={isFieldsDisabled}
            label={t('client.client.contacts.phone.label')}
            name="contacts.phone"
            placeholder={t('client.client.contacts.phone.placeholder')}
            readOnly={isFieldsReadOnly}
          />
        )}
      </GridFields>
    </Section>
  );
};
